import React from 'react';
import {View} from 'react-native';

import KeyboardFocusable from '/component/base/ExtKeyboard/KeyboardFocusable';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import metricSectionTestIDs from '/constant/TestIDs/MetricSection';
import {SHARE_OPTAVIA_PLAN} from '/enum/popover.enum';
import {EVENT_DATA, EVENT_NAMES, SCREEN_NAMES} from '/enum/tealium.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {getTealiumUtilDefaultInstance} from '/util/tealium';
import testProperties from '/util/testing/testProperties';

import {styles} from './SharePlanButton.style';
interface SharePlanButtonProps {
  onNavigate: (
    route: string,
    params: {modalName: string; modalProps: object},
  ) => void;
  lastPaidRank: string;
  highestAchievedRank: string;
  coachCurrentRank: string;
  coachID: string | number;
  onAddCandidatePress: () => void;
  onShowCandiate: () => void;
}
const MAX_FONT_SIZE_MULTIPLIER = 2;

export const SharePlanButton: React.FC<SharePlanButtonProps> = ({
  onNavigate = () => {},
  lastPaidRank = '',
  highestAchievedRank = '',
  coachCurrentRank = '',
  coachID = '',
}) => {
  const {tt} = useTranslation('screen.SharePlanButton');
  const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
    eventName: EVENT_NAMES.CTA_Click,
  });
  const coachIdStr = coachID.toString();
  const buttonLabel = tt('sharePlan', 'Select a Plan');
  const handlePress = () => {
    sendEvent({
      screenName: SCREEN_NAMES.client,
      CTAtext: EVENT_DATA.CTAtextShareBundle,
      CTAtype: EVENT_DATA.CTAtype,
      targetLocation: EVENT_DATA.targetLocation,
      lastPaidRank: lastPaidRank,
      coachHighestRank: highestAchievedRank,
      coachCurrentRank: coachCurrentRank,
      coachID: coachIdStr,
    });
    onNavigate('card', {modalName: SHARE_OPTAVIA_PLAN, modalProps: {}});
  };
  return (
    <KeyboardFocusable
      {...testProperties(metricSectionTestIDs.metricSharePlanButton, true)}
      style={styles.buttonWrapper}
      accessible={true}
      accessibilityRole="button"
      accessibilityLabel={buttonLabel}
      accessibilityHint="Opens options to share your Optavia plan"
      onPress={handlePress}>
      <View style={styles.buttonContainer} accessible={false}>
        <View style={styles.buttonTextContainer}>
          <Text
            variant="button"
            style={styles.button}
            allowFontScaling
            maxFontSizeMultiplier={MAX_FONT_SIZE_MULTIPLIER}
            accessible={false}
            {...testProperties(
              metricSectionTestIDs.metricSharePlanButtonLabel,
            )}>
            {buttonLabel}
          </Text>
        </View>
        <Icon
          name="ios_share_24dp_nostroke"
          style={styles.icon}
          {...testProperties(metricSectionTestIDs.metricSharePlanButtonIcon)}
        />
      </View>
    </KeyboardFocusable>
  );
};
